var $555da7c493321513$exports = {};
document.addEventListener("DOMContentLoaded", function() {
    const checkbox = document.getElementById("checkbox");
    document.body.classList.toggle("dark");
    checkbox.addEventListener("change", ()=>{
        document.body.classList.toggle("dark");
        console.log("testing this out");
    });
});


//# sourceMappingURL=index.500226ab.js.map
